import React, { useEffect } from 'react';
import { Button } from 'antd';
import 'antd/dist/antd.css';
import { Link, RouteComponentProps } from 'react-router-dom';
import { FaUserEdit, FaUserLock, FaUserMinus } from 'react-icons/fa';
import { getProfesseur } from './personnel.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const PersonnelOptions = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;
  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);
  const personnel = useAppSelector(state => state.professeur.entity);
  useEffect(() => {
    dispatch(getProfesseur(props.match.params.id));
  }, []);

  const hasUserAccount = [
    'SECRETAIRE',
    'COMPTABLE',
    'DIRECTEUR',
    'DIRECTEUR_ETUDE',
    'SURVEILLANT',
    'SURVEILLANT_GENERAL',
    'CONTROLEUR_BUS',
  ];
  return (
    <div className="pt-2" style={{ marginBottom: 100 }}>
      <h4>Options</h4>
      {hasUserAccount && (
        <Button style={{ backgroundColor: '#ffc107', color: 'black', borderRadius: 16 }} className="mb-2">
          <Link to="/account/reset/request" id="jh-create-entity" data-cy="entityCreateButton">
            <FaUserLock title="reset" />
            &nbsp; Réinitialiser mot de passe
          </Link>
        </Button>
      )}
      <Button type="primary" style={{ borderRadius: 16, textAlign: 'center' }}>
        <Link to={`/personnel/${ecoleId}/${id}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserEdit title="editer" />
          &nbsp; Modifier
        </Link>
      </Button>
      <Button style={{ marginTop: 5, backgroundColor: '#dc3545', color: 'white', borderRadius: 16 }}>
        <Link to={`/personnel/${ecoleId}/${id}/delete`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserMinus title="delete" />
          &nbsp; Supprimer
        </Link>
      </Button>
    </div>
  );
};

export default PersonnelOptions;
